import { fr } from "@codegouvfr/react-dsfr";

import illustration from "src/assets/img/search.svg";

export const SearchInfoSection = () => (
  <section
    className={fr.cx(
      "fr-container",
      "fr-grid-row",
      "fr-grid-row--center",
      "fr-pb-9w",
    )}
  >
    <div className={fr.cx("fr-col-lg-8", "fr-col-12", "fr-pr-4w")}>
      <h2>
        Le saviez-vous ? La majorité des candidats obtiennent une réponse après
        4 candidatures à des offres différentes. Ne vous découragez pas !
      </h2>
      <p>
        Les entreprises ne répondent pas à 100% des sollicitations, cela n’a
        rien à voir avec vous, ne vous découragez pas !
      </p>
    </div>
    <div className={fr.cx("fr-col-lg-4")}>
      <img src={illustration} alt="" />
    </div>
  </section>
);
